import React, { Component } from "react";

import Navbar from "./CustomHeader";
import SideBar from "./CustomSidebar";

export class AdminLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div className="container-scroller">
        <Navbar />
        <div className="container-fluid page-body-wrapper">
          <SideBar />
          <div className="main-panel">
            <div className="content-wrapper">{this.props.children}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default AdminLayout;
